var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M763 715L763 743",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 763.5,
    cy: 710.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M758.987 710.19C758.987 706.283 762.288 703.117 766.358 703.117C766.943 703.117 767.511 703.184 768.056 703.308C766.742 702.48 765.187 702 763.519 702C758.814 702 755 705.806 755 710.5C755 715.194 758.814 719 763.519 719C765.814 719 767.895 718.093 769.427 716.62C768.492 717.032 767.454 717.263 766.358 717.263C762.288 717.263 758.987 714.096 758.987 710.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M772.402 709.6L772.37 707.146L770.535 708.719L768.304 708.056L769.112 710.337L767.765 712.381L770.1 712.218L771.499 714.144L772.133 711.763L774.345 710.909L772.402 709.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.9c9c91f829ecc3aeef138a1b6184bf18.svg";
export { ForwardRef as ReactComponent };